<template>
  <div class="trip-photos-field">
    <p v-if="existingPhotos.length" class="trip-photos-section-title">Текущие фото</p>
    <div v-if="existingPhotos.length" class="trip-photos-previews">
      <div
        v-for="photo in existingPhotos"
        :key="`existing-${photo.id}`"
        class="trip-photo-preview"
      >
        <img :src="photo.thumb_url || photo.url" :alt="photo.filename || 'Фото'" />
      </div>
    </div>

    <label class="trip-photos-label">
      {{ addLabel }}
      <input
        ref="fileInput"
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        hidden
        @change="onFilesSelected"
      />
    </label>
    <button type="button" class="btn btn-secondary btn-sm" @click="fileInput?.click()">
      Добавить фото
    </button>

    <div v-if="pendingPhotos.length" class="trip-photos-previews">
      <div
        v-for="(photo, index) in pendingPhotos"
        :key="`pending-${index}`"
        class="trip-photo-preview"
      >
        <img :src="photo.previewUrl" :alt="photo.file.name" />
        <button type="button" class="btn btn-secondary btn-sm" @click="removePending(index)">
          Удалить
        </button>
      </div>
    </div>

    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script setup>
import { onBeforeUnmount, ref } from 'vue'

const MAX_PHOTOS = 50

const props = defineProps({
  existingPhotos: {
    type: Array,
    default: () => [],
  },
  addLabel: {
    type: String,
    default: 'Фотографии поездки',
  },
})

const pendingPhotos = defineModel('pendingPhotos', {
  type: Array,
  default: () => [],
})

const fileInput = ref(null)
const error = ref('')

function onFilesSelected(event) {
  const files = Array.from(event.target.files || [])
  event.target.value = ''
  if (!files.length) return

  error.value = ''

  const total = props.existingPhotos.length + pendingPhotos.value.length + files.length
  if (total > MAX_PHOTOS) {
    error.value = `Не больше ${MAX_PHOTOS} фотографий`
    return
  }

  const added = files.map((file) => ({
    file,
    previewUrl: URL.createObjectURL(file),
  }))

  pendingPhotos.value = [...pendingPhotos.value, ...added]
}

function removePending(index) {
  const photo = pendingPhotos.value[index]
  if (photo?.previewUrl) URL.revokeObjectURL(photo.previewUrl)
  pendingPhotos.value = pendingPhotos.value.filter((_, i) => i !== index)
}

onBeforeUnmount(() => {
  pendingPhotos.value.forEach((photo) => {
    if (photo.previewUrl) URL.revokeObjectURL(photo.previewUrl)
  })
})
</script>

<style scoped>
.trip-photos-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.trip-photos-label {
  display: none;
}

.trip-photos-section-title {
  margin: 0;
  font-weight: 600;
}

.trip-photos-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.trip-photo-preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.trip-photo-preview img {
  max-width: 160px;
  max-height: 120px;
  border-radius: 0.5rem;
  object-fit: cover;
}
</style>
